export class ServiceResponse {
  public RequestSuccessful: boolean = false;
  public ErrorMessage: string = '';
}
